export type ContentType = "news" | "video" | "encyclopedia";

export interface ContentItem {
  id: string;
  type: ContentType;
  title: string;
  summary: string;
  source: string;
  author: string;
  date: string;
  image: string;
  category: string;
  tags: string[];
  popularity: number;
  duration?: string;
  views?: string;
  content: string[];
}

export const contentItems: ContentItem[] = [
  {
    id: "n1",
    type: "news",
    title: "全国多地迎来秋冬季文旅消费旺季",
    summary:
      "入秋以来，全国多个城市陆续推出主题文旅活动和惠民消费举措，博物馆、古镇、主题公园客流稳步上升，夜间经济成为新的增长点。",
    source: "百度一下·新闻",
    author: "本台记者 李岚",
    date: "2026-10-12",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20bright%20modern%20lakeside%20ancient%20town%20filled%20with%20visitors%20during%20autumn%20season%2C%20warm%20daylight%2C%20clean%20balanced%20composition%2C%20soft%20natural%20tones%2C%20high%20detail%20and%20calm%20atmosphere&width=800&height=500&seq=news-01&orientation=landscape",
    category: "国内",
    tags: ["文旅", "消费", "夜经济"],
    popularity: 96,
    content: [
      "随着天气转凉，全国各地陆续进入秋冬季文旅消费旺季。多个城市围绕“赏秋”“夜游”“非遗体验”等主题，推出了一系列贴近市民需求的活动。",
      "在一些历史文化街区，夜间灯光秀与市集相结合，吸引了大量年轻游客前来打卡。有关部门表示，将在保障安全和秩序的前提下，进一步丰富夜间文旅产品供给。",
      "业内观察人士认为，文旅消费的持续升温，既反映出居民休闲需求的稳步释放，也带动了餐饮、住宿、交通等相关行业的联动增长。",
      "需要说明的是，本页数据为演示内容，用于展示搜索与内容聚合的交互流程。",
    ],
  },
  {
    id: "n2",
    type: "news",
    title: "我国新一代运载火箭完成关键地面试验",
    summary:
      "新一代运载火箭近日完成关键地面试验，多项技术指标达到预期，为后续飞行任务奠定基础。相关团队表示将继续推进后续验证工作。",
    source: "百度一下·新闻",
    author: "本台记者 周远",
    date: "2026-10-11",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20tall%20clean%20white%20rocket%20standing%20in%20a%20modern%20high%20tech%20assembly%20facility%2C%20bright%20neutral%20lighting%2C%20minimal%20composition%2C%20crisp%20industrial%20details%2C%20calm%20professional%20atmosphere&width=800&height=500&seq=news-02&orientation=landscape",
    category: "国内",
    tags: ["航天", "科技", "试验"],
    popularity: 91,
    content: [
      "记者从相关单位了解到，新一代运载火箭近日顺利完成关键地面试验，试验过程中的多项技术指标达到预期目标。",
      "试验团队介绍，本次验证覆盖了结构、动力与控制系统在典型工况下的协同表现，为后续飞行任务积累了重要数据。",
      "下一步，团队将继续推进后续测试与验证工作，按计划稳步开展相关准备。",
      "本页内容为演示数据，仅用于展示资讯浏览与聚合效果。",
    ],
  },
  {
    id: "n3",
    type: "news",
    title: "全球气候大会聚焦绿色能源转型",
    summary:
      "在最新一届全球气候大会上，与会各方围绕绿色能源转型、碳减排路径和技术合作展开讨论，多项合作倡议受到关注。",
    source: "百度一下·新闻",
    author: "本台记者 陈曦",
    date: "2026-10-10",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20sunlit%20landscape%20with%20modern%20wind%20turbines%20and%20solar%20panels%20across%20green%20fields%2C%20clear%20sky%2C%20clean%20balanced%20composition%2C%20soft%20natural%20tones%2C%20bright%20and%20hopeful%20atmosphere&width=800&height=500&seq=news-03&orientation=landscape",
    category: "国际",
    tags: ["气候", "能源", "国际"],
    popularity: 88,
    content: [
      "本届全球气候大会吸引了来自各地的代表参加，绿色能源转型成为核心议题之一。",
      "与会代表就能源结构优化、清洁技术推广以及跨区域合作等方向交换了意见，并提出了多项合作倡议。",
      "观察人士指出，绿色转型既是应对气候变化的长期方向，也为相关产业带来新的发展机遇。",
      "本页内容为演示数据，用于展示搜索结果页与详情页的内容对应关系。",
    ],
  },
  {
    id: "n4",
    type: "news",
    title: "多国推动跨境电子商务新规落地",
    summary:
      "近期，多个经济体围绕跨境电子商务的合规、物流与消费者权益保护推出新举措，行业普遍关注规则统一带来的影响。",
    source: "百度一下·新闻",
    author: "本台记者 何嘉",
    date: "2026-10-09",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20bright%20modern%20logistics%20warehouse%20with%20neat%20parcel%20shelves%20and%20a%20delivery%20truck%20outside%2C%20clean%20daylight%2C%20minimal%20professional%20composition%2C%20calm%20neutral%20tones&width=800&height=500&seq=news-04&orientation=landscape",
    category: "国际",
    tags: ["电商", "跨境", "规则"],
    popularity: 79,
    content: [
      "多个经济体近期陆续推出与跨境电子商务相关的新规定，覆盖通关、物流时效以及消费者权益保护等方面。",
      "业内人士表示，规则的逐步统一有助于降低跨境交易的不确定性，但也对企业的合规能力提出了更高要求。",
      "相关行业协会建议，经营主体应密切关注政策变化，及时调整业务流程。",
      "本页内容为演示数据，不代表任何真实政策信息。",
    ],
  },
  {
    id: "n5",
    type: "news",
    title: "前三季度国民经济运行数据发布",
    summary:
      "最新发布的数据显示，前三季度主要经济指标总体保持平稳，消费与服务业的恢复态势较为明显，市场活力进一步显现。",
    source: "百度一下·新闻",
    author: "本台记者 吴倩",
    date: "2026-10-08",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20bright%20modern%20business%20district%20skyline%20seen%20from%20above%2C%20clean%20daylight%2C%20calm%20professional%20composition%2C%20soft%20neutral%20tones%2C%20high%20detail%20and%20orderly%20atmosphere&width=800&height=500&seq=news-05&orientation=landscape",
    category: "财经",
    tags: ["经济", "数据", "服务业"],
    popularity: 94,
    content: [
      "最新发布的数据显示，前三季度主要经济指标总体保持平稳运行，结构优化与动能转换持续推进。",
      "从行业看，消费与服务业恢复态势较为明显，与居民生活密切相关领域的活力进一步提升。",
      "分析人士认为，随着各项举措逐步落地，市场主体的信心有望得到进一步巩固。",
      "本页内容为演示数据，仅用于展示资讯列表与详情页的浏览体验。",
    ],
  },
  {
    id: "n6",
    type: "news",
    title: "新能源汽车销量持续攀升",
    summary:
      "行业数据显示，新能源汽车市场保持较快增长，产品供给日益丰富，充电等配套设施建设也在同步推进。",
    source: "百度一下·新闻",
    author: "本台记者 郑楠",
    date: "2026-10-07",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20sleek%20modern%20electric%20car%20charging%20at%20a%20bright%20clean%20charging%20station%2C%20soft%20daylight%2C%20minimal%20balanced%20composition%2C%20calm%20neutral%20tones%2C%20high%20detail&width=800&height=500&seq=news-06&orientation=landscape",
    category: "财经",
    tags: ["新能源", "汽车", "市场"],
    popularity: 90,
    content: [
      "行业数据显示，新能源汽车市场继续保持较快增长，产品供给日益丰富，覆盖多个价格区间。",
      "与此同时，充电等配套设施建设同步推进，用户使用便利性得到改善。",
      "业内观点认为，随着技术迭代和成本优化，新能源汽车的普及仍有较大空间。",
      "本页内容为演示数据，用于展示关键词相关的搜索结果聚合。",
    ],
  },
  {
    id: "n7",
    type: "news",
    title: "全国运动会开幕 多项纪录被刷新",
    summary:
      "全国运动会正式开幕，多个项目在首日展开激烈角逐，部分项目刷新了赛会纪录，现场气氛热烈。",
    source: "百度一下·新闻",
    author: "本台记者 孙浩",
    date: "2026-10-06",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20bright%20modern%20stadium%20track%20with%20athletes%20competing%2C%20clear%20daylight%2C%20clean%20dynamic%20composition%2C%20soft%20neutral%20tones%2C%20energetic%20yet%20orderly%20atmosphere&width=800&height=500&seq=news-07&orientation=landscape",
    category: "体育",
    tags: ["运动会", "纪录", "竞技"],
    popularity: 87,
    content: [
      "全国运动会正式开幕，来自各地的代表团在多个项目中展开激烈角逐。",
      "开幕式后进行的比赛中，部分项目刷新了赛会纪录，为观众带来了精彩表现。",
      "赛事组织方表示，将继续做好服务保障，为运动员创造良好的比赛环境。",
      "本页内容为演示数据，仅用于展示体育类资讯的浏览效果。",
    ],
  },
  {
    id: "n8",
    type: "news",
    title: "城市马拉松赛季火热开启",
    summary:
      "随着秋季到来，多个城市的马拉松赛事陆续开跑，参与人数众多，赛事带动了本地餐饮、住宿与文旅消费。",
    source: "百度一下·新闻",
    author: "本台记者 林越",
    date: "2026-10-05",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20large%20city%20marathon%20with%20runners%20on%20a%20wide%20clean%20street%20in%20autumn%2C%20soft%20morning%20light%2C%20balanced%20dynamic%20composition%2C%20calm%20neutral%20tones&width=800&height=500&seq=news-08&orientation=landscape",
    category: "体育",
    tags: ["马拉松", "赛事", "消费"],
    popularity: 82,
    content: [
      "进入秋季，多个城市的马拉松赛事陆续开跑，吸引了大量跑步爱好者参与。",
      "不少赛事结合本地文化特色设置路线，带动了餐饮、住宿与文旅等相关消费。",
      "赛事主办方提醒参与者合理分配体力，注意赛前准备与赛后恢复。",
      "本页内容为演示数据，出场数据与成绩均为虚构。",
    ],
  },
  {
    id: "n9",
    type: "news",
    title: "人工智能大模型加速赋能千行百业",
    summary:
      "人工智能大模型在办公、教育、制造等领域的应用不断拓展，越来越多的行业开始探索与自身业务相结合的落地方式。",
    source: "百度一下·新闻",
    author: "本台记者 赵一鸣",
    date: "2026-10-04",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20bright%20minimal%20modern%20technology%20office%20with%20a%20large%20screen%20showing%20abstract%20data%20visualization%2C%20soft%20daylight%2C%20clean%20composition%2C%20calm%20neutral%20tones%2C%20high%20detail&width=800&height=500&seq=news-09&orientation=landscape",
    category: "科技",
    tags: ["人工智能", "大模型", "应用"],
    popularity: 98,
    content: [
      "人工智能大模型正加速融入各类业务场景，在办公、教育、制造等领域的应用不断拓展。",
      "多家机构表示，正在探索将大模型能力与自身业务流程相结合，以提升效率和服务体验。",
      "与此同时，业内也强调在数据安全、内容合规等方面需要持续完善相应机制。",
      "本页内容为演示数据，用于展示科技类资讯与搜索交互。",
    ],
  },
  {
    id: "v1",
    type: "video",
    title: "三分钟看懂量子计算",
    summary:
      "用通俗的方式讲解量子计算的基本概念与可能的应用方向，帮助观众在短时间内建立整体认识。",
    source: "百度一下·视频",
    author: "科普频道",
    date: "2026-10-13",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20abstract%20digital%20illustration%20of%20glowing%20interconnected%20particles%20representing%20quantum%20computing%2C%20dark%20neutral%20background%2C%20soft%20light%2C%20minimal%20elegant%20composition%2C%20high%20tech%20calm%20atmosphere&width=800&height=500&seq=video-01&orientation=landscape",
    category: "科普",
    tags: ["量子计算", "科普", "科技"],
    popularity: 93,
    duration: "03:12",
    views: "128.6万次播放",
    content: [
      "本期视频从最基础的“比特与量子比特的区别”讲起，用生活中的类比帮助观众理解量子计算的核心思想。",
      "视频随后介绍了量子计算可能发挥作用的几个方向，包括材料模拟、优化问题等。",
      "需要提醒的是，视频为演示内容，播放器为前端模拟交互，暂无真实视频源。",
    ],
  },
  {
    id: "v2",
    type: "video",
    title: "秋日旅行 Vlog：走进古城",
    summary:
      "跟随镜头走进秋日的古城，记录街巷、小店与日落，感受慢节奏的城市气息。",
    source: "百度一下·视频",
    author: "旅行日常",
    date: "2026-10-12",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20travel%20video%20still%20of%20a%20quiet%20ancient%20town%20alley%20in%20autumn%20with%20warm%20sunset%20light%20and%20lanterns%2C%20soft%20natural%20tones%2C%20calm%20peaceful%20atmosphere%2C%20high%20detail&width=800&height=500&seq=video-02&orientation=landscape",
    category: "生活",
    tags: ["旅行", "Vlog", "古城"],
    popularity: 85,
    duration: "05:40",
    views: "76.2万次播放",
    content: [
      "这段 Vlog 记录了古城清晨到日落的一整天，镜头里既有热闹的主街，也有安静的小巷。",
      "视频中穿插了当地的特色小吃与手工艺店铺，呈现了较为完整的生活气息。",
      "本视频为演示内容，画面与播放均为前端模拟，不涉及真实素材。",
    ],
  },
  {
    id: "v3",
    type: "video",
    title: "高效记忆法公开课",
    summary:
      "一堂面向学生的公开课，介绍几种实用的记忆方法，并结合例子演示如何在学习中运用。",
    source: "百度一下·视频",
    author: "教育公开课",
    date: "2026-10-11",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20bright%20minimal%20classroom%20scene%20with%20notebooks%20and%20a%20chalkboard%2C%20soft%20daylight%2C%20calm%20orderly%20composition%2C%20neutral%20tones%2C%20high%20detail%20editorial%20style&width=800&height=500&seq=video-03&orientation=landscape",
    category: "教育",
    tags: ["学习", "记忆", "公开课"],
    popularity: 80,
    duration: "12:05",
    views: "54.8万次播放",
    content: [
      "公开课围绕“如何记得更快、更牢”展开，介绍了联想记忆、图像记忆等常用方法。",
      "讲师结合具体学科内容进行演示，帮助观众理解方法的使用场景。",
      "本视频为演示内容，播放器为前端模拟交互。",
    ],
  },
  {
    id: "v4",
    type: "video",
    title: "精彩赛事集锦：全场高光时刻",
    summary:
      "汇集近期多场赛事的精彩瞬间，快速回顾关键时刻与高光表现。",
    source: "百度一下·视频",
    author: "体育集锦",
    date: "2026-10-10",
    image:
      "https://readdy.ai/api/search-image?query=Dynamic%20sports%20highlight%20video%20still%20of%20a%20bright%20modern%20stadium%20with%20athletes%20in%20motion%2C%20clear%20daylight%2C%20energetic%20clean%20composition%2C%20soft%20neutral%20tones&width=800&height=500&seq=video-04&orientation=landscape",
    category: "体育",
    tags: ["赛事", "集锦", "高光"],
    popularity: 83,
    duration: "08:21",
    views: "102.4万次播放",
    content: [
      "本期集锦收录了近期多场比赛中的关键瞬间，节奏紧凑，方便快速回顾。",
      "片头与片尾附有简要的赛事说明，帮助观众了解背景。",
      "本视频为演示内容，画面与数据均为虚构。",
    ],
  },
  {
    id: "v5",
    type: "video",
    title: "解读最新经济数据",
    summary:
      "用图表与讲解结合的方式，梳理最新经济数据的主要看点，帮助观众理解背后的趋势。",
    source: "百度一下·视频",
    author: "财经观察",
    date: "2026-10-09",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20financial%20data%20visualization%20scene%20with%20abstract%20charts%20on%20a%20bright%20screen%2C%20soft%20daylight%2C%20calm%20professional%20composition%2C%20neutral%20tones%2C%20high%20detail&width=800&height=500&seq=video-05&orientation=landscape",
    category: "财经",
    tags: ["经济", "数据", "解读"],
    popularity: 78,
    duration: "06:33",
    views: "48.1万次播放",
    content: [
      "视频以图表形式呈现了主要经济指标的变化趋势，并逐项做出简要解读。",
      "讲解尽量使用通俗语言，降低理解门槛。",
      "本视频为演示内容，数据与图表均用于展示交互流程。",
    ],
  },
  {
    id: "v6",
    type: "video",
    title: "家常菜十分钟教程",
    summary:
      "十分钟教你做一道简单易学的家常菜，步骤清晰，适合日常快速上手。",
    source: "百度一下·视频",
    author: "美食日记",
    date: "2026-10-08",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20food%20photography%20style%20video%20still%20of%20a%20simple%20home%20cooked%20dish%20on%20a%20minimal%20wooden%20table%2C%20soft%20daylight%2C%20calm%20appetizing%20composition%2C%20neutral%20background&width=800&height=500&seq=video-06&orientation=landscape",
    category: "美食",
    tags: ["美食", "教程", "家常菜"],
    popularity: 74,
    duration: "04:18",
    views: "63.5万次播放",
    content: [
      "本期教程从备料开始，逐步演示烹饪过程，每个步骤都配有清晰提示。",
      "视频结尾附有小贴士，帮助调整口味。",
      "本视频为演示内容，食材与步骤仅用于展示。",
    ],
  },
  {
    id: "v7",
    type: "video",
    title: "未来城市智能交通演示",
    summary:
      "通过动画演示未来城市中智能交通系统的运作方式，展示车路协同与调度优化的想象空间。",
    source: "百度一下·视频",
    author: "科技前沿",
    date: "2026-10-07",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20clean%20city%20traffic%20simulation%20visualization%20with%20glowing%20routes%20and%20modern%20streets%2C%20calm%20neutral%20palette%2C%20minimal%20elegant%20composition%2C%20high%20detail%20render&width=800&height=500&seq=video-07&orientation=landscape",
    category: "科技",
    tags: ["智能交通", "未来", "演示"],
    popularity: 81,
    duration: "09:07",
    views: "57.9万次播放",
    content: [
      "视频以动画形式呈现了车路协同、实时调度等概念，帮助观众理解智能交通的整体思路。",
      "内容以概念演示为主，不涉及具体技术实现细节。",
      "本视频为演示内容，播放器为前端模拟交互。",
    ],
  },
  {
    id: "e1",
    type: "encyclopedia",
    title: "人工智能",
    summary:
      "人工智能是研究、开发用于模拟和扩展人类智能的理论、方法、技术及应用系统的一门技术科学。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-13",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20abstract%20illustration%20of%20a%20glowing%20neural%20network%20of%20connected%20nodes%20symbolizing%20artificial%20intelligence%2C%20soft%20light%2C%20minimal%20elegant%20composition%2C%20neutral%20palette%2C%20high%20detail&width=800&height=500&seq=enc-01&orientation=landscape",
    category: "科技",
    tags: ["人工智能", "计算机", "科技"],
    popularity: 99,
    content: [
      "人工智能（Artificial Intelligence，简称 AI）是研究、开发用于模拟和扩展人类智能的理论、方法、技术及应用系统的一门技术科学。",
      "它通常涉及机器学习、自然语言处理、计算机视觉等方向，并在办公、教育、制造等多个领域得到应用。",
      "本词条为演示内容，用于展示百科类内容的浏览方式。",
    ],
  },
  {
    id: "e2",
    type: "encyclopedia",
    title: "量子计算",
    summary:
      "量子计算是利用量子力学特性进行信息处理的计算方式，其基本单元为量子比特，具备与经典计算不同的特点。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-12",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20illustration%20of%20a%20quantum%20computing%20concept%20with%20interfering%20waves%20and%20particles%2C%20soft%20light%2C%20clean%20elegant%20composition%2C%20neutral%20palette%2C%20high%20detail&width=800&height=500&seq=enc-02&orientation=landscape",
    category: "科技",
    tags: ["量子计算", "物理", "计算"],
    popularity: 92,
    content: [
      "量子计算是利用量子力学特性进行信息处理的计算方式，其基本单元称为量子比特。",
      "与经典比特不同，量子比特可以处于叠加态，从而在某些特定问题上具备潜在优势。",
      "本词条为演示内容，用于展示百科检索与浏览交互。",
    ],
  },
  {
    id: "e3",
    type: "encyclopedia",
    title: "新能源汽车",
    summary:
      "新能源汽车指采用非常规车用燃料作为动力来源的汽车，包括纯电动、插电式混合动力等类型。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-11",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20illustration%20of%20a%20modern%20electric%20vehicle%20silhouette%20with%20soft%20charging%20symbol%2C%20light%20neutral%20background%2C%20elegant%20composition%2C%20high%20detail&width=800&height=500&seq=enc-03&orientation=landscape",
    category: "交通",
    tags: ["新能源汽车", "交通", "能源"],
    popularity: 90,
    content: [
      "新能源汽车是指采用非常规车用燃料作为动力来源的汽车，常见类型包括纯电动汽车、插电式混合动力汽车等。",
      "近年来，随着技术进步与配套设施完善，新能源汽车的保有量持续增长。",
      "本词条为演示内容，数据用于展示百科内容结构。",
    ],
  },
  {
    id: "e4",
    type: "encyclopedia",
    title: "气候变化",
    summary:
      "气候变化指气候平均状态在长时间尺度上出现的显著改变，通常与温室气体排放等因素相关。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-10",
    image:
      "https://readdy.ai/api/search-image?query=Calm%20abstract%20illustration%20of%20earth%20climate%20concept%20with%20subtle%20atmosphere%20layers%20and%20soft%20blue%20and%20green%20tones%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=800&height=500&seq=enc-04&orientation=landscape",
    category: "科学",
    tags: ["气候变化", "环境", "科学"],
    popularity: 84,
    content: [
      "气候变化指气候平均状态在长时间尺度上出现的显著改变，通常与温室气体排放等因素有关。",
      "应对气候变化已成为国际社会共同关注的重要议题。",
      "本词条为演示内容，用于展示百科类页面的检索交互。",
    ],
  },
  {
    id: "e5",
    type: "encyclopedia",
    title: "马拉松",
    summary:
      "马拉松是一项长跑运动，标准距离为 42.195 公里，起源于古代的一次长距离奔跑传说。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-09",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20illustration%20of%20long%20distance%20running%20with%20a%20runner%20silhouette%20and%20distance%20markers%2C%20light%20neutral%20background%2C%20elegant%20composition%2C%20high%20detail&width=800&height=500&seq=enc-05&orientation=landscape",
    category: "体育",
    tags: ["马拉松", "跑步", "运动"],
    popularity: 76,
    content: [
      "马拉松是一项长跑运动，标准距离为 42.195 公里，起源与古代长距离奔跑的传说有关。",
      "如今，马拉松赛事在全球广泛开展，成为大众参与度较高的运动之一。",
      "本词条为演示内容，用于展示体育类百科的浏览方式。",
    ],
  },
  {
    id: "e6",
    type: "encyclopedia",
    title: "数字经济",
    summary:
      "数字经济是以数据资源为关键要素、以数字技术为核心驱动力的经济形态，涵盖广泛的产业与应用场景。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-08",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20abstract%20illustration%20of%20digital%20economy%20concept%20with%20data%20streams%20and%20network%20grid%2C%20soft%20light%2C%20minimal%20elegant%20composition%2C%20neutral%20palette%2C%20high%20detail&width=800&height=500&seq=enc-06&orientation=landscape",
    category: "经济",
    tags: ["数字经济", "数据", "经济"],
    popularity: 83,
    content: [
      "数字经济是以数据资源为关键要素、以数字技术为核心驱动力的经济形态。",
      "它涵盖电子商务、平台经济、智能制造等多个应用场景。",
      "本词条为演示内容，用于展示百科内容的聚合展示。",
    ],
  },
  {
    id: "e7",
    type: "encyclopedia",
    title: "大运河",
    summary:
      "大运河是世界上开凿较早、规模较大的运河之一，在历史上对南北经济文化交流起到了重要作用。",
    source: "百度一下·百科",
    author: "百科编辑组",
    date: "2026-10-07",
    image:
      "https://readdy.ai/api/search-image?query=Calm%20editorial%20photography%20of%20a%20wide%20ancient%20canal%20with%20stone%20bridges%20and%20reflections%20at%20dusk%2C%20soft%20natural%20tones%2C%20balanced%20peaceful%20composition%2C%20high%20detail&width=800&height=500&seq=enc-07&orientation=landscape",
    category: "历史",
    tags: ["大运河", "历史", "文化"],
    popularity: 72,
    content: [
      "大运河是世界上开凿较早、规模较大的运河之一，在历史上对南北经济与文化交流起到了重要作用。",
      "沿线城市因运河而兴，留下了丰富的文化遗产。",
      "本词条为演示内容，用于展示历史类百科的浏览体验。",
    ],
  },
];

export const contentTypeLabels: Record<ContentType, string> = {
  news: "新闻",
  video: "视频",
  encyclopedia: "百科",
};

export const newsCategories = ["全部", "国内", "国际", "财经", "体育", "科技"];
export const videoCategories = ["全部", "科普", "生活", "教育", "体育", "财经", "美食", "科技"];
export const videoDurations = ["全部", "3分钟以内", "3-10分钟", "10分钟以上"];
export const encyclopediaCategories = ["全部", "科技", "交通", "科学", "体育", "经济", "历史"];